module.exports = __webpack_public_path__ + "static/media/Platform.ada1a7f3.svg";